import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';

import { Folder } from '@qality/common-model';

import { useTestCaseRepositoryIssuesContext } from '../../TestCaseRepositoryIssuesProvider';
import { useTestCaseRepositorySelectionContext } from '../../TestCaseRepositorySelectionProvider';

type Props = {
  isDisabled?: boolean;
  folder: Folder;
};

export function TestCaseRepositoryTableBulkSelectCheckbox({
  isDisabled = false,
  folder,
}: Props): JSX.Element {
  const { areAllIssuesSelected, toggleBulkSelectIssues } =
    useTestCaseRepositorySelectionContext();

  const { issues, selectionKey } = useTestCaseRepositoryIssuesContext();

  return (
    <Checkbox
      isChecked={!isDisabled && areAllIssuesSelected(selectionKey, issues)}
      onChange={() => toggleBulkSelectIssues(selectionKey, issues, folder)}
      isDisabled={isDisabled}
    />
  );
}
